import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputMaskComponent } from './input-mask.component';

import { NgxMaskModule } from 'ngx-mask';


@NgModule({
  declarations: [
    InputMaskComponent
  ],
  imports: [
    CommonModule,
    NgxMaskModule.forRoot()
  ],
  exports: [
    InputMaskComponent
  ]
})
export class InputMaskModule { }
